var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.4089 2.10908C1.96707 2.10908 1.6089 2.46725 1.6089 2.90908V13.0909C1.6089 13.5327 1.96707 13.8909 2.4089 13.8909H12.5907C13.0325 13.8909 13.3907 13.5327 13.3907 13.0909V7.27272C13.3907 6.91122 13.6838 6.61817 14.0453 6.61817C14.4068 6.61817 14.6998 6.91122 14.6998 7.27272V13.0909C14.6998 14.2557 13.7555 15.2 12.5907 15.2H2.4089C1.24408 15.2 0.299805 14.2557 0.299805 13.0909V2.90908C0.299805 1.74426 1.24408 0.799988 2.4089 0.799988H8.22708C8.58857 0.799988 8.88162 1.09304 8.88162 1.45453C8.88162 1.81603 8.58857 2.10908 8.22708 2.10908H2.4089ZM13.6089 2.81518C13.6018 2.82155 13.5945 2.82779 13.587 2.8339L7.97087 8.5421C7.69109 8.77101 7.27871 8.72977 7.0498 8.44999C6.82089 8.17021 6.86213 7.75783 7.14191 7.52891L12.689 1.8909H10.7725C10.5315 1.8909 10.3362 1.69554 10.3362 1.45454C10.3362 1.21354 10.5315 1.01818 10.7725 1.01818H14.0453C14.2863 1.01818 14.4816 1.21354 14.4816 1.45454V4.72727C14.4816 4.96826 14.2863 5.16363 14.0453 5.16363C13.8043 5.16363 13.6089 4.96826 13.6089 4.72727V2.81518Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTab);
export default __webpack_public_path__ + "static/media/new-tab.c672668efb2bf0247833f17baf06d657.svg";
export { ForwardRef as ReactComponent };